
import { defineComponent } from "vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";

export default defineComponent({
  components: {
    IntegerControl,
  },
  props: {
    model: { required: true },
  },
  methods: {},
  created(){
    this.modelLocal = this.model;    
  },
  data(){
    return {
      modelLocal: null,
      weight: [{name: "cabinAxle", top: 345, left: 160},
        {name: "tractorFirstAxle", top: 345, left: 350}, 
        {name: "semitrailerFirstAxle", top: 345, left: 570},
        {name: "semitrailerSecondAxle", top: 345, left: 640}],
      distance: [{name: "tractorAxlesDistanceFirst", top: 152, left: 283, width: 40},
        {name: "tractorAxlesDistanceSecond", top: 152, left: 333, width: 40},
        {name: "semitrailerAxlesDistanceFirst", top: 155, left: 610, width: 56},
        {name: "tractorCabinAxlesDistance", top: 290, left: 260, width: 56},
        {name: "tractorSemitrailerAxlesDistance", top: 113, left: 430, width: 56}],
    };
  },
});
